import { useTranslation } from 'react-i18next';
import { cn } from '@anytag/shared-utils';
import { ComboboxOption, ComboboxLabel, useComboboxState } from '@anyui/core';
import { Icon } from '../../Icon';
import { TextCutter } from '../../TextCutter';
import { useSingleSelectContext } from '../select-context';

export interface SelectCreateOptionProps {
  className?: string;
}

export const SelectCreateOption = ({ className }: SelectCreateOptionProps) => {
  const { t } = useTranslation();
  const filteredOptionsCount = useComboboxState((state) => state.filtered.count);
  const {
    search,
    createPrefix,
    selectProps: { creatable, classNames, loading, multiple }
  } = useSingleSelectContext();

  return !multiple && creatable && !loading && search.trim() && !filteredOptionsCount ? (
    <ComboboxOption
      keywords={[search]}
      value={`${createPrefix}${search}`}
      className={cn(className, classNames?.option)}
      forceMount
    >
      <Icon icon="plus" size={12} />
      <ComboboxLabel className={classNames?.label}>
        <TextCutter text={t('Create "{{search}}"', { search })} lines={1} />
      </ComboboxLabel>
    </ComboboxOption>
  ) : null;
};
